import React from "react";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import AppReducers from "./reducers";
import Routes from "./routers";
import ReactGA from "react-ga";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

// create redux store
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  AppReducers,
  undefined,
  composeEnhancers(applyMiddleware(thunk))
);

// recaptcha key
const recaptchaSiteKey = "6LfuKbYZAAAAAEsVlf5mpJ4qfTyo0XukOu7uCuK4";

class App extends React.Component {
  componentDidMount() {
    ReactGA.initialize("UA-173221846-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <Provider store={store}>
        <GoogleReCaptchaProvider
          reCaptchaKey={recaptchaSiteKey}
          language={"en"}
          useRecaptchaNet={false}
        >
          <Routes />
        </GoogleReCaptchaProvider>
      </Provider>
    );
  }
}

export default App;
